<template>
  <div class="resultSignature_warpper">
    <nav-bar titleText="签名结果" titleWeight="bold" @goBack="goBack"></nav-bar>
    <results-page
      @handleOperationClick="handleOperationClick"
      @handleReturnClick="handleReturnClick"
      operationDisplab
      operationText="查看订单"
      returnDisplab
      returnText="返回"
      :imgSrc="imgSrc"
      instructions="已成功签名"
    >
      <p class="p1">已成功签名</p>
      <p v-if="showtype" class="p2">注：签名完成后，请及时联系债权人【{{phone}}】收回借据凭证</p>
    </results-page>
  </div>
</template>
<script>
import navBar from "../components/navBar";
import resultsPage from "../components/resultsPage";
export default {
  name: "debt_resultSignature",
  data() {
    return {
     imgSrc:  require("../../../assets/debtor/resultOk.png"),
     phone:'',
     showtype:false
    }; 
  },
  created() {
    if(this.$route.query.identity == 'debtor'){
        this.$api.post('contract/member/contract/info', {contract_id:this.$route.query.contract_id,})
          .then(data => {
             data.contract_role_info.forEach(element => {
               if(element.ext_info.mark == '债权人'){
                 this.phone = element.ext_info.phone
               }
           });
          })
      this.showtype = true
    }else{
     this.showtype = false
    }
   
  },  
  components: {
    navBar,
    resultsPage,
  },
  methods: {
    goBack() {
      this.handleOperationClick()
    },
    handleOperationClick() {//id:this.$route.query.id
      // 到详情页
      let path = ''
      if (this.$route.query.identity === 'debtor') {
        path = '/debtor/detail'
      }
      if (this.$route.query.identity === 'creditor') {
        path = '/creditor/detail'
      }
      
      this.$router.push({
        path: path,
        query: {
          order_id: this.$route.query.order_id
        },
      })
    },
    handleReturnClick() {
      // 到各角色首页、列表页
      let path = ''
      if (this.$route.query.identity === 'debtor') {
        path = '/debtor/debtorView'
      }
      if (this.$route.query.identity === 'creditor') {
        path = '/creditor/creditorView'
      }
      
      this.$router.push({
        path: path,
        query: {
          debtor_from: 'resultSign',
        },
      })
    }
  }
};
</script>
<style lang="less">
.resultSignature_warpper {
  padding-top: 88px;
  box-sizing: border-box;
  background-color: #f5f6f7;
  min-height: 100%;
  font-size: 16px;
  color: #333;
  .p1 {
    margin-bottom: 17px;
    font-size: 15px;
  }
  .p2 {
    margin:0 46px 36px;
    font-size: 14px;
  }
}
</style>





